import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translation files
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import pt from './locales/pt.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import ar from './locales/ar.json';
import hi from './locales/hi.json';
import sw from './locales/sw.json';
import ht from './locales/ht.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  pt: { translation: pt },
  zh: { translation: zh },
  ja: { translation: ja },
  ko: { translation: ko },
  ar: { translation: ar },
  hi: { translation: hi },
  sw: { translation: sw },
  ht: { translation: ht },
};

// Custom language detector that checks localStorage first
const localStorageDetector = {
  name: 'localStoragePreference',
  lookup() {
    return localStorage.getItem('preferredLanguage');
  }
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(localStorageDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStoragePreference', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

// Function to load and merge custom translations from backend
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export async function loadCustomTranslations(language) {
  try {
    const response = await fetch(`${BACKEND_URL}/api/translations/custom/${language}`);
    if (response.ok) {
      const data = await response.json();
      const customTranslations = data.translations || {};
      
      // Merge custom translations with existing ones
      if (Object.keys(customTranslations).length > 0) {
        // Convert flat keys to nested object
        const nested = {};
        for (const [key, value] of Object.entries(customTranslations)) {
          const parts = key.split('.');
          let current = nested;
          for (let i = 0; i < parts.length - 1; i++) {
            if (!current[parts[i]]) current[parts[i]] = {};
            current = current[parts[i]];
          }
          current[parts[parts.length - 1]] = value;
        }
        
        // Deep merge with existing translations
        i18n.addResourceBundle(language, 'translation', nested, true, true);
        console.log(`[i18n] Loaded ${Object.keys(customTranslations).length} custom translations for ${language}`);
      }
    }
  } catch (error) {
    console.warn('[i18n] Failed to load custom translations:', error);
  }
}

// Load custom translations on language change
i18n.on('languageChanged', (lng) => {
  loadCustomTranslations(lng);
});

// Load custom translations for initial language
if (typeof window !== 'undefined') {
  loadCustomTranslations(i18n.language);
}

export default i18n;
